import { SkeletonCard } from "./SkeletonCard";

export function SkeletonMetric({ label }: { label: string }) {
  return (
    <SkeletonCard>
      <span className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">
        {label}
      </span>
      <span className="mt-4 block h-8 w-28 animate-pulse rounded-full bg-muted motion-reduce:animate-none" />
    </SkeletonCard>
  );
}
